import apiClient from "./apiClient";

export const getSearchTool = async (tool) => {
  try {
    const res = await apiClient.get(`tool/search-tool/${tool}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getAllTools = async () => {
  try {
    const res = await apiClient.get("/tool/get-all-tools");
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getToolById = async (toolId) => {
  try {
    const res = await apiClient.get(`/tool/get-tool/${toolId}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteToolById = async (toolId) => {
  const serverId = localStorage.getItem("server_id");
  try {
    const res = await apiClient.delete(`/server/tool/${toolId}/remove`, {
      headers: { mcp_server_id: serverId },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteToolActionById = async (actionId) => {
  const serverId = localStorage.getItem("server_id");
  try {
    const res = await apiClient.delete(
      `server/tool/action/${actionId}/remove`,
      {
        headers: { mcp_server_id: serverId },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const connectTool = async ({
  provider,
  scopes,
  redirect,
  auth_method,
  access_token,
  server_url,
}) => {
  try {
    if (auth_method === "personal_access_token") {
      // For PAT authentication, use POST to /oauth/authenticate
      const payload = {
        provider,
        auth_method,
        personal_access_token: access_token,
        server_url: server_url || null,
      };

      const userId = localStorage.getItem("mcp_user_id");
      const res = await apiClient.post("/oauth/authenticate", payload, {
        headers: {
          "Content-Type": "application/json",
          user_id: userId,
        },
      });
      return res.data;
    } else {
      // For OAuth, use GET to /oauth/authorize
      const params = {
        provider,
        scopes,
        redirect,
        auth_method: "oauth",
      };
      const res = await apiClient.get("/oauth/authorize", { params });
      return res.data;
    }
  } catch (err) {
    console.error("Connect tool error:", err);
    
    // Enhance error information for better debugging
    const enhancedError = {
      ...err,
      provider,
      auth_method,
      scopes: scopes?.substring(0, 50) + "..." // Partial scopes for debugging
    };
    
    console.error("Enhanced connect tool error details:", enhancedError);
    
    // Re-throw the original error for upstream handling
    throw err;
  }
};

export const OAuthCallback = async (provider, payload, userId) => {
  try {
    const res = await apiClient.post(`/oauth/callback/${provider}`, payload, {
      headers: {
        "Content-Type": "application/json",
        user_id: userId,
      },
    });
    return res.data;
  } catch (err) {
    console.error("OAuth callback error:", err);
    
    // Enhance error information for better debugging
    const enhancedError = {
      ...err,
      provider,
      userId: userId?.substring(0, 8) + "...", // Log partial userId for debugging
      payload: {
        ...payload,
        code: payload.code?.substring(0, 8) + "...", // Partial code for debugging
      }
    };
    
    console.error("Enhanced OAuth callback error details:", enhancedError);
    
    // Re-throw the original error for upstream handling
    throw err;
  }
};

export const updateActionNeeds = async (actionId, payload) => {
  try {
    const serverId = localStorage.getItem("server_id");

    const res = await apiClient.put(
      `/server/update-needs/${actionId}`,
      payload,
      {
        headers: { mcp_server_id: serverId },
      }
    );

    return res.data;
  } catch (err) {
    throw err;
  }
};

// api/history.js or in your main api.js file
export const getHistoryLogs = async (serverId) => {
  try {
    const res = await apiClient.get(
      `/history/get-history-logs?serverId=${serverId}`
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};
